import { useEffect, useState } from "react";

import { useContestTerritories } from "~/entity/ContestTerritories";

export interface IRegionOption {
  value: string;
  label: string;
}

/**
 * Опции регионов для селекта.
 * Источник — candidate-бэкенд: GET /candidate/regions
 * (тот же сервис, что и competitive-territories), список отсортирован по имени.
 * value — строковый id региона (geoPlaceId в API конкурсных территорий):
 * FilterField из ~/features/filter хранит значение селекта строкой,
 * поэтому number-опции в фильтре не матчились бы с выбранным значением.
 * В payload формы конвертируется обратно в number.
 */
export const useSubjectOptions = () => {
  const { getRegions } = useContestTerritories();
  const [options, setOptions] = useState<IRegionOption[]>([]);
  const [loading, setLoading] = useState(false);

  const getSocr = (socr: string) => {
    if (socr === "обл" || socr === "г" || socr === "Респ" || socr === "респ") {
      return socr + ".";
    }

    return socr;
  };

  useEffect(() => {
    const loadRegions = async () => {
      setLoading(true);
      try {
        const regions = await getRegions();
        setOptions(
          (regions ?? []).map((item) => ({
            value: String(item.id),
            label: item.name + " " + getSocr(item.socr),
          })),
        );
      } catch (error) {
        console.error("Ошибка при загрузке списка регионов:", error);
        setOptions([]);
      } finally {
        setLoading(false);
      }
    };
    loadRegions();
  }, [getRegions]);

  return { options, loading };
};
